import React from 'react';
import styles from './prompt-suggestions.module.css';

interface PromptSuggestionsProps {
  suggestions: string[];
  onSuggestionClick: (suggestion: string) => void;
}

export const PromptSuggestions: React.FC<PromptSuggestionsProps> = ({ suggestions, onSuggestionClick }) => {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <div className={styles.suggestionsWrapper}>
      <div className={styles.suggestionsInner}>
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            className={styles.suggestionButton}
            onClick={() => onSuggestionClick(suggestion)}
            style={{ animationDelay: `${index * 70}ms` }}
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  );
};
